// Studio Mix tokens as CSS-var references — auto-adapt to body.dark
export const SM = {
  bg: 'var(--bg)',
  bgAlt: 'var(--bg-alt)',
  surface: 'var(--surface)',
  surface2: 'var(--surface-2)',
  border: 'var(--border)',
  borderStrong: 'var(--border-strong)',
  text: 'var(--text)',
  textDim: 'var(--text-dim)',
  textFaint: 'var(--text-faint)',
  primary: 'var(--primary)',
  primaryInk: 'var(--primary-ink)',
  primarySoft: 'var(--primary-soft)',
  grad: 'var(--grad)',
  up: 'var(--up)',
  upSoft: 'var(--up-soft)',
  upInk: 'var(--up-ink)',
  down: 'var(--down)',
  downSoft: 'var(--down-soft)',
  downInk: 'var(--down-ink)',
  amber: 'var(--amber)',
  amberSoft: 'var(--amber-soft)',
  amberInk: 'var(--amber-ink)',
  font: '"Inter Tight", "Heebo", system-ui, sans-serif',
} as const;
